export const BILLING_STRIPE = 'stripe';
export const BILLING_STRIPE_SAVED_CARD = 'stripe-saved-card';
export const BILLING_PAYPAL = 'paypal';
export const BILLING_PROMOCODE = 'promocode';
export const BILLING_GITHUB = 'github';